import { Component, input } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-steps',
  styleUrl: './steps.scss',
  templateUrl: './steps.html',
})
export class Steps {
  current = input.required<number>();
  total = input.required<number>();
}
